import { Trans } from '@/plugins/Translation';

// Containers
const Main = () => import('@/App.vue');
const Home = () => import('@/views/home');
const ListingDetail = () => import('@/views/listingDetail/ListingDetail');
const ExternalAdsScreen = () => import('@/views/externalAds/');
const Payment = () => import('@/views/payment');
const PaymentSuccess = () => import('@/views/payment/paymentSuccess');
const SellerDetail = () => import('@/views/sellerDetail');
const SpecialDeals = () => import('@/views/specialDeals');
const ViewPDF = () => import('@/views/admin/viewPDF');
const Callback = () => import('@/views/Callback');
const LogoutCallback = () => import('@/views/LogoutCallback');
const UserPackageScreen = () => import('@/views/userPackageScreen');
const FaqScreen = () => import('@/views/faqScreen');
const EditListing = () => import('@/views/editListing/EditListing');
// Search
const MobileAdvanceSearch = () => import('@/views/search/mobile/SearchMobile');
const SearchGrid = () => import('@/views/search/Search');
// Dashboard
const AdminDashboard = () =>
	import('@/views/admin/adminDashboard/AdminDashboard');
const UserDashboard = () => import('@/views/admin/userDashboard/UserDashboard');
const AdsDashboard = () => import('@/views/admin/adsDashboard/AdsDashboard');
const AgencyInvitation = () => import('@/views/agencyInvitation/AgencyInvitation');
const FourZeroFour = () => import('@/views/404/404');
const Activities = () => import('@/views/activities/');
const ActivitiesHelp = () => import('@/views/activities/help');
const ActivitiesBecomeCompany = () => import('@/views/activities/become-company');
const ActivitiesChiniesNewYear = () => import('@/views/activities/chinies-new-year');
const ActivitiesSongkran = () => import('@/views/activities/songkran');
const ActivitiesNew = () => import('@/views/activities/new');
const ActivitiesSevenSeven = () => import('@/views/activities/7-7');
const ActivitiesCombo = () => import('@/views/activities/combo');

const routes = [
	{
		path: '/:lang',
		name: 'Home',
		component: Home,
		meta: {
			title: 'ข่าวสด - มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/callback',
		name: 'Callback',
		component: Callback,
		meta: {
			title: 'ข่าวสด - มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/logout-callback',
		name: 'LogoutCallback',
		component: LogoutCallback,
		meta: {
			title: 'ข่าวสด - มาร์เก็ตเพลส',
			guest: true
		}
	},
	// SEARCH
	{
		path: '/:lang/search',
		name: 'SearchGrid',
		component: SearchGrid,
		meta: {
			title: 'หน้าค้นหา มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/advance-search',
		name: 'MobileAdvanceSearch',
		component: MobileAdvanceSearch,
		meta: {
			title: 'ค้นหาโดยละเอียด มาร์เก็ตเพลส',
			guest: true
		}
	},
	// LISTING
	{
		path: '/:lang/add-listing',
		name: 'AddListing',
		component: EditListing,
		meta: {
			title: 'ลงประกาศ มาร์เก็ตเพลส',
			userAuth: true
		},
		props: true
	},
	{
		path: '/:lang/edit-listing/:id',
		name: 'EditListing',
		component: EditListing,
		meta: {
			title: 'แก้ไขข้อมูลประกาศ มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/listing-detail/:id',
		name: 'ListingDetail',
		component: ListingDetail,
		props: true,
		meta: {
			title: 'รายละเอียดประกาศ มาร์เก็ตเพลส',
			guest: true
		}
	},
	// PAYMENT
	{
		path: '/:lang/payment/:id',
		name: 'Payment',
		component: Payment,
		props: true,
		meta: {
			title: 'หน้าชำระเงิน มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/payment-success/:id/pending/:previousPendingPaymentId?',
		name: 'PaymentSuccess',
		component: PaymentSuccess,
		props: true,
		meta: {
			title: 'หน้าชำระเงิน มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/seller-detail/:id',
		name: 'SellerDetail',
		component: SellerDetail,
		meta: {
			title: 'รายละเอียดของผู้ขาย มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/special-deals/',
		name: 'SpecialDeals',
		component: SpecialDeals,
		meta: {
			title: 'มาร์เก็ตเพลส',
			guest: true
		}
	},
	// UserDashboard
	{
		path: '/:lang/user-dashboard',
		name: 'UserMain',
		component: UserDashboard,
		meta: {
			title: 'แผงควบคุม มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/message',
		name: 'UserMessage',
		component: UserDashboard,
		params: {
			component: 'UserMessage'
		},
		meta: {
			title: 'กล่องข้อความ มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/user-manage',
		name: 'UserManageListing',
		component: UserDashboard,
		meta: {
			title: 'ประกาศของฉัน มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/user-manage-agents',
		name: 'UserManageAgents',
		component: UserDashboard,
		meta: {
			title: 'มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/user-payment',
		name: 'UserPayment',
		component: UserDashboard,
		meta: {
			title: 'การชำระเงินของฉัน มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/user-profile',
		name: 'Profile',
		component: UserDashboard,
		meta: {
			title: 'ข้อมูลผู้ใช้ มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/coins/:previousPendingPaymentId?',
		name: 'UserKhaosodCoins',
		component: UserDashboard,
		meta: {
			title: 'เหรียญ มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/user-statistic',
		name: 'UserStatistic',
		component: UserDashboard,
		meta: {
			title: 'วิเคราะห์สถิติ มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/user-contact',
		name: 'UserContact',
		component: UserDashboard,
		meta: {
			title: 'ติดต่อ / แจ้งปัญหาการใช้งาน มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/view-ad-placement',
		name: 'ViewPDF',
		component: ViewPDF,
		meta: {
			title: 'มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/packages-screen/:id',
		name: 'UserPackageScreen',
		component: UserPackageScreen,
		meta: {
			title: 'เลือกโปรโมตประกาศ มาร์เก็ตเพลส',
			userAuth: true
		}
	},
	{
		path: '/:lang/faq',
		name: 'FaqScreen',
		component: FaqScreen,
		meta: {
			title: 'คำถามที่พบบ่อย มาร์เก็ตเพลส',
			guest: true
		}
	},
	// AdminDashboard
	{
		path: '/:lang/admin-dashboard',
		name: 'AdminMain',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-profile',
		name: 'AdminProfile',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-message',
		name: 'AdminMessage',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-approve-listing',
		name: 'AdminApproveListing',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-approve-listing/:id',
		name: 'AdminListingDetail',
		component: ListingDetail,
		props: true,
		meta: {
			title: 'Approve Listing',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-manage-listing',
		name: 'AdminManageListing',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-manage-listing-sold-rented',
		name: 'AdminManageListingSoldRented',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-media',
		name: 'AdminMedia',
		component: AdminDashboard,
		meta: {
			title: 'Admin Media',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-discount-list',
		name: 'adminDiscountList',
		component: AdminDashboard,
		meta: {
			title: 'Admin discount list',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-special-deals',
		name: 'AdminManageSpecialDeals',
		component: AdminDashboard,
		meta: {
			title: 'Admin Special Deals',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-manage-agency',
		name: 'AdminManageAgency',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-manage-users',
		name: 'AdminManageUsers',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-payment-history',
		name: 'AdminPaymentHistory',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-statistics',
		name: 'AdminStatistic',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-email',
		name: 'AdminEmailTemplatePreview',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-website-config',
		name: 'AdminWebsiteConfig',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},
	{
		path: '/:lang/admin-add-admin',
		name: 'AdminAddAdmin',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard',
			adminAuth: true
		}
	},

	// AdsDashboard
	{
		path: '/:lang/add-customer',
		name: 'AdsAddCustomer',
		component: AdsDashboard,
		meta: {
			title: 'Add Customer',
			adminAuth: true
		}
	},
	{
		path: '/:lang/create-ads/:screen',
		name: 'AdsCreateAds',
		component: AdsDashboard,
		meta: {
			title: 'Ads Homepage',
			adminAuth: true
		}
	},
	{
		path: '/:lang/ads-admin-profile',
		name: 'Profile',
		component: AdsDashboard,
		meta: {
			title: 'Admin Profile',
			adminAuth: true
		}
	},
	{
		path: '/:lang/ads',
		name: 'ExternalAdsScreen',
		component: ExternalAdsScreen,
		meta: {
			title: 'โฆษณากับเรา มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/404',
		name: '404',
		component: FourZeroFour,
		meta: {
			title: 'โฆษณากับเรา มาร์เก็ตเพลส',
			guest: true
		}
	},
	{
		path: '/:lang/agency-invitation',
		name: 'AgencyInvitation',
		component: AgencyInvitation,
		meta: {
			title: 'โฆษณากับเรา อสังหาฯ',
			guest: true
		}
	},
	{
		path: '/:lang/activities/Christmas-HappyNewYear-2022',
		name: 'Activities',
		component: Activities,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/activities/chinese-newyear-2022',
		name: 'ActivitiesChiniesNewYear',
		component: ActivitiesChiniesNewYear,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/activities/combo',
		name: 'ActivitiesCombo',
		component: ActivitiesCombo,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/activities/6.6',
		name: 'ActivitiesNew',
		component: ActivitiesNew,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/activities/7.7',
		name: 'ActivitiesSevenSeven',
		component: ActivitiesSevenSeven,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/activities/songkran',
		name: 'ActivitiesSongkran',
		component: ActivitiesSongkran,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/topics/how-to-post-listing',
		name: 'ActivitiesHelp',
		component: ActivitiesHelp,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		path: '/:lang/topics/become-company',
		name: 'ActivitiesBecomeCompany',
		component: ActivitiesBecomeCompany,
		meta: {
			title: 'โฆษณากับเรา ซื้อ-ขาย',
			guest: true
		}
	},
	{
		// Redirect user to supported lang version.
		path: '*',
		redirect(to, from, next) {
			return Trans.getUserSupportedLang();
		}
	}
];

export default routes;
